const scaleFactor = {
    base: 1,
    scaled: 1.12
}

function scaleActionCard(k, actionCard, shouldScale) {
    k.tween(
        actionCard.scale.x,
        shouldScale ? scaleFactor.scaled : scaleFactor.base,
        0.2,
        v => actionCard.scale = k.vec2(v),
        k.easings.easeOutBack
    );
}

export {
    scaleFactor,
    scaleActionCard
}